import angular from 'angular';
import CategoriesInputFilter from './categories-input-filter.component';

let CategoriesFilterModule = angular.module('catalog.categoriesFilter.categoriesInputFilter', [])
  .component('categoriesInputFilter', CategoriesInputFilter);

export default CategoriesFilterModule;



// WEBPACK FOOTER //
// ./www/components/catalog/categories-filter/categories-input-filter/categories-input-filter.js